import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';

// eslint-disable-next-line react/prop-types
const LanguagePicker = ({ t, allowNone, className, id, onChange, size }) => {
  const [languages] = useState([
    {
      id: 'es',
      description: 'Español',
    },
    {
      id: 'en',
      description: 'English',
    },
  ]);

  return (
    <div>
      <Input
        type="select"
        bsSize={size || 'md'}
        value={id}
        onChange={onChange}
        className={className || ''}
      >
        {(id === 0 || allowNone) && (
          <option role="option" value="">{t('LanguagePicker.description')}</option>
        )}
        {languages.map((l) => (
          <option role="option" key={l.id} value={l.id}>
            {l.description}
          </option>
        ))}
      </Input>
    </div>
  );
};

LanguagePicker.propTypes = {
  allowNone: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(LanguagePicker);
